import { Button, Col, Empty, Row } from 'antd';
import OfferCard from 'components/offerCard';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const ProviderOffers = props => {
  // const offers = props.offers;
  const offers = useSelector(state => state.appTrack?.activeOffers);
  const dummyResponse = [
    {
      id: 12,
      provider: 'Cosmote',
      offerCode: 'c365432',
      offerName: 'COSMO 48',
      description: '100% Εγγυημένη ταχύτητα 1000 Mbps για πλοήγηση στο Internet Απεριόριστα λεπτά προς σταθερά Απεριόριστα λεπτά προς κινητά',
      costWithoutSubsidy: '50€ / μήνα ΔΩΡΕΑΝ για 3 μήνες Χωρίς κόστος ενεργοποίησης',
      subsidizedCost: '45€ / μήνα ΔΩΡΕΑΝ για 6 μήνες Χωρίς κόστος ενεργοποίησης',
      link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      additionalInfo:
        'Για σταθερά εκτός Ελλάδος εφαρμόζονται επιπλέον χρεώσεις 0.10 ευρώ/λεπτό',
      providersInfra: '1',
      uploads: [
        {
          id: 14,
          code: null,
          submissionDate: '2024-08-27T15:58:38.566129',
          user: 'beneficiary',
          status: 'Pending',
          fileName: 'offers2.xlsx',
        },
      ],
      voucherEntities: [],
    },
    {
      id: 12,
      provider: 'Cosmote',
      offerCode: 'c365432',
      offerName: 'COSMO 49',
      description: '100% Εγγυημένη ταχύτητα 1000 Mbps για πλοήγηση στο Internet Απεριόριστα λεπτά προς σταθερά',
      costWithoutSubsidy: '50€ / μήνα ΔΩΡΕΑΝ για 3 μήνες Χωρίς κόστος ενεργοποίησης',
      subsidizedCost: '45€ / μήνα ΔΩΡΕΑΝ για 6 μήνες Χωρίς κόστος ενεργοποίησης',
      link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      additionalInfo:
        'Για σταθερά εκτός Ελλάδος εφαρμόζονται επιπλέον χρεώσεις 0.10 ευρώ/λεπτό',
      providersInfra: '1',
      uploads: [
        {
          id: 14,
          code: null,
          submissionDate: '2024-08-27T15:58:38.566129',
          user: 'beneficiary',
          status: 'Pending',
          fileName: 'offers2.xlsx',
        },
      ],
      voucherEntities: [],
    },
    {
      id: 13,
      provider: 'Cosmote',
      offerCode: 'c365432',
      offerName: 'COSMO 50',
      description: '100% Εγγυημένη ταχύτητα 1000 Mbps για πλοήγηση στο Internet Απεριόριστα λεπτά προς όλους',
      costWithoutSubsidy: '50€ / μήνα ΔΩΡΕΑΝ για 3 μήνες Χωρίς κόστος ενεργοποίησης',
      subsidizedCost: '45€ / μήνα ΔΩΡΕΑΝ για 6 μήνες Χωρίς κόστος ενεργοποίησης',
      link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      additionalInfo:
        'Για σταθερά εκτός Ελλάδος εφαρμόζονται επιπλέον χρεώσεις 0.10 ευρώ/λεπτό',
      providersInfra: '1',
      uploads: [
        {
          id: 14,
          code: null,
          submissionDate: '2024-08-27T15:58:38.566129',
          user: 'beneficiary',
          status: 'Pending',
          fileName: 'offers2.xlsx',
        },
      ],
      voucherEntities: [],
    },
    {
      id: 15,
      provider: 'Cosmote',
      offerCode: 'c365432',
      offerName: 'COSMO 48',
      offerInternet: '1000 Mbps για πλοήγηση στο Internet',
      offerLandline: 'Απεριόριστα λεπτά προς σταθερά εντός Ελλάδος',
      offerMobile:
        '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
      amount: 63.89,
      link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      additionalInfo:
        'Για σταθερά εκτός Ελλάδος εφαρμόζονται επιπλέον χρεώσεις 0.10 ευρώ/λεπτό',
      providersInfra: '1',
      uploads: [
        {
          id: 14,
          code: null,
          submissionDate: '2024-08-27T15:58:38.566129',
          user: 'beneficiary',
          status: 'Pending',
          fileName: 'offers2.xlsx',
        },
      ],
      voucherEntities: [],
    },
    {
      id: 14,
      provider: 'Vodafone',
      offerCode: 'π25432',
      offerName: 'Vodafone 300',
      offerInternet: null,
      offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
      offerMobile:
        '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
      amount: 363.8,
      link: 'link2',
      additionalInfo: 'info2',
      providersInfra: '1',
      uploads: [
        {
          id: 14,
          code: null,
          submissionDate: '2024-08-27T15:58:38.566129',
          user: 'beneficiary',
          status: 'Pending',
          fileName: 'offers2.xlsx',
        },
      ],
      voucherEntities: [],
    },
    {
      id: 13,
      provider: 'Vodafone',
      offerCode: 'π16543',
      offerName: 'Vodafone Surf',
      offerInternet: '1000 Mbps για πλοήγηση στο Internet',
      offerLandline: 'fixed1',
      offerMobile:
        '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
      amount: 29.8,
      link: 'link1',
      additionalInfo:
        'some more info what what that should wrap in multiple lines and describe multiple things about the offer with great detail or maybe not',
      providersInfra: '1',
      uploads: [
        {
          id: 14,
          code: null,
          submissionDate: '2024-08-27T15:58:38.566129',
          user: 'beneficiary',
          status: 'Pending',
          fileName: 'offers2.xlsx',
        },
      ],
      voucherEntities: [],
    },
  ];
  const groupedResponse = offers && !isEmpty(offers)
    ? Object.groupBy(sortBy(offers, ['offerName']), ({ provider }) => provider)
    : {};

  const dummyOffers = {
    Cosmote: [
      {
        offerCode: 'XXXXX5',
        offerName: 'COSMO 48',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile:
          '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX0',
        offerName: 'COSMO 42',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile:
          '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX1',
        offerName: 'COSMO 45',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile:
          '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX2',
        offerName: 'COSMO 46',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile:
          '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX3',
        offerName: 'COSMO 47',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile:
          '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
    ],
    Vodafone: [
      {
        offerCode: 'XXXXX5',
        offerName: 'VODA 48',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile:
          '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX0',
        offerName: 'VODA 42',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile: '300 λεπτά προς όλα τα κινητά εντός Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo:
          '1000 Mbps για πλοήγηση στο Internet Απεριόριστα λεπτά προς σταθερά 300 λεπτά προς όλα τα κινητά εντός Ευρωπαϊκής Ένωσης',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX1',
        offerName: 'VODA 45',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile: '300 λεπτά προς όλα τα κινητά εντός Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX2',
        offerName: 'VODA 46',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile:
          '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX3',
        offerName: 'VODA 47',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile: '300 λεπτά προς όλα τα κινητά εντός Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX0',
        offerName: 'VODA 42',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile: '300 λεπτά προς όλα τα κινητά εντός Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo:
          '1000 Mbps για πλοήγηση στο Internet Απεριόριστα λεπτά προς σταθερά 300 λεπτά προς όλα τα κινητά εντός Ευρωπαϊκής Ένωσης',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
    ],
    Nova: [
      {
        offerCode: 'XXXXX5',
        offerName: 'NOVA 48',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile:
          '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: 'some more info what what',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX0',
        offerName: 'NOVA 42',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile:
          '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX1',
        offerName: 'NOVA 45',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile:
          '300 λεπτά προς όλα τα κινητά εντός Ελλάδος και Ευρωπαϊκής Ένωσης',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX2',
        offerName: 'NOVA 46',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        offerMobile: '300 λεπτά προς όλα τα κινητά εντός Ελλάδος',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
      {
        offerCode: 'XXXXX3',
        offerName: 'NOVA 47',
        offerInternet: '1000 Mbps για πλοήγηση στο Internet',
        offerLandline: 'Απεριόριστα λεπτά προς σταθερά',
        amount: 50.9,
        additionalInfo: '',
        link: 'https://www.cosmote.gr/eshop/go/Fixed%20Plans/Double%20Play%20Plans/Double%20Play%20Fiberspeed%20up%20to%201%20Gbps/rateplan/COSMOTE%20Fiber%201%20Gbps%20Unlimited',
      },
    ],
  };
  const [expandedProvider, setExpandedProvider] = useState('');

  const renderCard = offer => {
    return (
      <Col xs={24} sm={12} xl={6}>
        <OfferCard offer={offer} />
      </Col>
    );
  };

  const renderOffers = offers => {
    const offersKeys = !isEmpty(offers) ? Object.keys(offers).sort() : []
    return (
      <>
        {isEmpty(offersKeys) && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>No data</>} />  //comment in when providers offers go to prod
          // <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
          //   <>
          //     Οι εγκεκριμένες προσφορές των Παρόχων θα αναρτηθούν 
          //     στην πλατφόρμα του Προγράμματος εντός των επόμενων ημερών.
          //   </>
          // } />     //comment out when providers offers go to prod
        )}
        {!isEmpty(offersKeys) &&
          offersKeys.map((key, index) => {
            return (
              <div
                key={key + index + '-provider'}
                id={key + index + '-provider'}
                className={`provider-wrapper${
                  expandedProvider === key ? ' expanded' : ''
                }`}
              >
                <Button
                  key={key + index + '-expand'}
                  id={key + index + '-expand'}
                  className="pseudo-expand offer-provider"
                  onClick={() =>
                    setExpandedProvider(expandedProvider === key ? '' : key)
                  }
                >
                  <span>{key}</span>
                  <span>{expandedProvider === key ? '-' : '+'}</span>
                </Button>
                <Row
                  // justify="space-between"
                  gutter={[16, 16]}
                  id={`${key}-offer-cards`}
                  className={`offer-cards-wrapper${
                    expandedProvider === key ? ' expanded' : ''
                  }`}
                >
                  {offers[key]?.map(o => renderCard(o))}
                </Row>
              </div>
            );
          })}
      </>
    );
  };

  return (
    <>
      <div id="provider-offers-component">{renderOffers(groupedResponse)}</div>
    </>
  );
};

export default ProviderOffers;
